export default __webpack_public_path__ + "visea logo.svg";